export default __webpack_public_path__ + "static/media/icon_arrow_down_12.564d2804.svg";